import styles from "./CoronationView.module.css"

export default function CoronationView() {
  return (
    <div className={styles.holder}>
      <div className={styles.pic1}>
        <div className={styles.pic1Content}>
          <p className={styles.text1}>A PLACE ALIVE WITH EXCITEMENT</p>
          <p className={styles.text2}>
            Coronation Square is a symbol of Leyton’s confidence in its role in
            21st Century London as a place to live, work, and grow. The
            fountains of the water feature bring a continental plaza feel,
            bouncing light and energy in a development bringing new jobs and
            investment and a new reason to love Leyton living.
          </p>
        </div>
        <img src="/assets/textures/gallery/lifestyle/img-4b.jpg" alt=""></img>
      </div>
      <div className={styles.pic2}>
        <div className={styles.pic2Content}>
          <p className={styles.text1}>
            THE CIVID-SQUARE - SOCIAL AND SUSTAINABLE
          </p>
          <p className={styles.text2}>
            The new public square is a focus for all Leyton, a dynamic space for
            outdoor markets and street performances, with a smart new market
            hall to assist seasoned businesses and nurture the new. and there
            are facilities to reduce, reuse, and recycle.
          </p>
        </div>
        <div className={styles.pic2Title}>
          <p className={styles.text1}>
            From the bustling high street to a green oasis. Enjoy all that
            Leyton has to offer.
          </p>
        </div>
        <img
          src="/assets/textures/gallery/coronation_square/img-1b.jpg"
          alt=""
        ></img>
      </div>
      <div className={styles.pic3}>
        <div className={styles.pic3Content}>
          <p className={styles.text1}>
            PLAY AREAS TO ENGAGE YOUNG MINDS AND BODIES
          </p>
          <p className={styles.text2}>
            The open spaces at Coronation Square are a mosaic of activities,
            textures and colours. Youngsters will love natural play areas like
            the lawns, equipped areas designed to foster imaginative play, as
            well as outdoor table-tennis tables while the water feature brings a
            big splash of extra fun.
          </p>
        </div>
        <div className={styles.pic3Title}>
          <p className={styles.text1}>
            PLAY AREAS TO ENGAGE YOUNG MINDS AND BODIES
          </p>
          <p className={styles.text2}>
            The open spaces at Coronation Square are a mosaic of activities,
            textures and colours. Youngsters will love natural play areas like
            the lawns, equipped areas designed to foster imaginative play, as
            well as outdoor table-tennis tables while the water feature brings a
            big splash of extra fun.
          </p>
        </div>
        <img
          src="/assets/textures/gallery/coronation_square/img-1e.jpg"
          alt=""
        ></img>
      </div>
    </div>
  )
}
